// This icon file is generated automatically.
var PDoubleLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M2.26 6L6.41.7c.06-.08 0-.2-.1-.2h-1.2a.25.25 0 00-.2.1l-4 5.1a.5.5 0 000 .6l4 5.1c.04.07.12.1.2.1h1.2c.1 0 .17-.12.1-.2L2.26 6zm4.75 0L11.16.7c.06-.08 0-.2-.1-.2h-1.2a.25.25 0 00-.2.1l-4 5.1a.5.5 0 000 .6l4 5.1c.04.07.12.1.2.1h1.2c.1 0 .16-.12.1-.2L7.01 6z", "fill-rule": "nonzero" } }] }, "name": "p-double-left", "theme": "outlined" };
export default PDoubleLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDoubleLeftOutlined.js
// module id = 3341
// module chunks = 0